<template>
  <div class="RequestManagementSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label>{{ $t("fromDate") }} : </label>
                    </td>
                    <td>
                      <div>
                        <dialog-date-picker
                          :label="$t('fromDate') + ':'"
                          :initDate="initBeginDate"
                          @dateResult="bDate"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>{{ $t("toDate") }} : </label>
                    </td>
                    <td>
                      <div>
                        <dialog-date-picker
                          :label="$t('toDate') + ':'"
                          :initDate="initEndDate"
                          @dateResult="eDate"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="sectionType">{{ $t("sectionType") }}: </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="sectionType"
                          :items="sectionTypes"
                          :label="$t('sectionType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeSectionType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="show">
                    <td>
                      <label for="requestType">{{ $t("requestType") }}:</label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="requestType"
                          :items="requestTypes"
                          :label="$t('requestType')"
                          item-text="Name"
                          item-value="Code"
                          return-object
                          dense
                          solo
                          v-on:change="changeRequestType"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
          <v-col>
            <div v-if="chkVisible">
              <div>
                <v-checkbox
                  dense
                  class="management-checkbox"
                  v-model="onlyCanApprove"
                  :label="$t('onlyCanApprove')"
                ></v-checkbox>
              </div>
              <div>
                <v-checkbox
                  dense
                  class="management-checkbox"
                  v-model="editedByMe"
                  :label="$t('editedByMe')"
                ></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import type from "../../model/RequestManagementType";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
import DialogDatePicker from "../widget/DialogDatePicker.vue";
export default {
  props: {
    accessTo: Number,
    approved:Boolean,
  },
  components: { DialogDatePicker },
  data() {
    return {
      requestTypes: [],
      requestType: "",
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      sectionType: "",
      sectionTypes: [],
      onlyCanApprove: true,
      editedByMe: false,
      chkVisible:true,
      show:true
    };
  },
  mounted() {
    var moment = require("jalali-moment");
    var year = moment().locale("fa").format("YYYY");
    this.initBeginDate = year + "/01/01";
    
    this.initEndDate = moment().locale("fa").endOf('year').format('YYYY/MM/DD')
    
    if (EosUtils.isWebKartAdmin()) {
      debugger;
      this.onlyCanApprove = false;
      this.chkVisible = false
      debugger;
    }

    this.requestTypes = type.RequestTypeArray();
    if (this.requestTypes.length > 0) {
      this.requestType = this.requestTypes[0];
    }
    

    this.loadSectionList();
    this.checkApproved();
  },

  methods: {
    bDate(date) {
      this.beginDate = date;
      this.search();
    },
    eDate(date) {
      this.endDate = date;
      this.search();
    },
    async loadSectionList() {
      if (EosUtils.isWebKartAdmin()) {
        this.getAllSection();
      } else if (this.accessTo) {
        this.getSectionWithPermissionNumber();
      }
    },
    checkApproved(){
      debugger
      if(this.approved){
        this.show=false;
        this.onlyCanApprove = false;
        this.chkVisible = false;
        this.editedByMe=false;
        this.requestType.Code=5;
        this.changeRequestType();
      }
    },
    getAllSection() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          this.search();
        }
      });
    },
    getSectionWithPermissionNumber() {
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: -1 });
      this.sectionType = this.sectionTypes[0];

      var params = new URLSearchParams();
      params.append("accessTo", this.accessTo);

      this.$store.dispatch("sections/GetSectionsList", { params }).then((result) => {
        //console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
        }
      });
    },
    changeRequestType() {
      this.search();
    },
    changeSectionType() {
      this.search();
    },
    search() {
      var searchParams = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        searchKind: this.requestType.Code,
        section: this.sectionType?.Code?.toString().trim() || "",
        editedByMe: this.editedByMe,
        onlyCanApprove: this.onlyCanApprove,
      };
      debugger;
      if(this.requestType.Code==2){
        // this.requestType.Code=5
        searchParams.searchKind=5
      }
      // else if(this.requestType.Code==5){
      //   // this.requestType.Code=2
      //   searchParams.searchKind=6
      // }

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

H
::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>